import GameWindow from './GameWindow';
export default GameWindow;